// extracted by mini-css-extract-plugin
module.exports = {"root":"PoweredBy_root__RuxWb","icon":"PoweredBy_icon__Bqi0H"};